import React, { useEffect, useState } from "react";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBjXsJKw3fTIysjrpKDeqSzuJNGuHexilA",
  authDomain: "moto-af0cb.firebaseapp.com",
  projectId: "moto-af0cb",
  storageBucket: "moto-af0cb.firebasestorage.app",
  messagingSenderId: "1083783072515",
  appId: "1:1083783072515:web:3ceb466b3f25ca4fc93736",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

interface FirebaseFileViewerProps {
  bucketName: string; // Dynamic bucket name (not used in Firebase)
  fileKey: string; // File path in Firebase Storage
  expiresIn?: number; // URL expiration time (not used in Firebase)
}

const FileViewer: React.FC<FirebaseFileViewerProps> = ({ bucketName, fileKey, expiresIn = 300 }) => {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const fileExtension = fileKey.split(".").pop()?.toLowerCase();

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const fileRef = ref(storage, fileKey);
        const url = await getDownloadURL(fileRef);
        setSignedUrl(url);
      } catch (error) {
        console.error("Error fetching download URL:", error);
      }
    };

    fetchSignedUrl();
  }, [fileKey]);

  if (!signedUrl) return <p>Loading file...</p>;

  return (
    <div className="p-4 border rounded shadow-md bg-white">
      {fileExtension?.match(/(jpg|jpeg|png|gif|bmp|svg)/) && (
        <img src={signedUrl} alt="Firebase Storage File" className="max-w-full max-h-[500px]" />
      )}

      {fileExtension === "pdf" && (
        <iframe src={signedUrl} className="w-full h-[500px]" title="PDF Viewer"></iframe>
      )}

      {fileExtension?.match(/(txt|log|json|csv)/) && (
        <iframe src={signedUrl} className="w-full h-[400px]" title="Text Viewer"></iframe>
      )}

      {!fileExtension?.match(/(jpg|jpeg|png|gif|bmp|svg|pdf|txt|log|json|csv)/) && (
        <div>
          <p>Cannot preview this file type.</p>
          <a href={signedUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Download File
          </a>
        </div>
      )}
    </div>
  );
};

export default FileViewer;
